export default __webpack_public_path__ + "static/media/Level36.56d4018f.svg";